import axios from 'axios'

export const getSysConfig = () => {
  return axios.get('settings/saller')
}

export const getConfigBySaler = (salerId) => {
  return axios.get('settings/saller/by-saler/' + salerId)
}

export const changeSysConfig = (data) => {
  return axios.post('settings/saller', data)
}

export const changeConfigBySaler = (salerId, data) => {
  return axios.post('settings/saller/by-saler/' + salerId, data)
}

export const resetSalerConfig = (salerId) => {
  return axios.delete('settings/saller/reset-config/' + salerId)
}



// WEBPACK FOOTER //
// ./src/api/saller.js